import { z } from 'zod';
import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const tunnelCategoryOptions = [
  'None',
  'TunnelBCDE',
  'TunnelCDE',
  'TunnelDE',
  'TunnelE',
] as const;

export const tunnelCategorySchema = createEnumSchemaPreprocessor(
  z.enum(tunnelCategoryOptions),
  tunnelCategoryOptions
);

export type TunnelCategoryType = z.infer<typeof tunnelCategorySchema>;
